import { useSelector } from 'react-redux';
import { TcsmStates } from '../../../../../root/tcsm-model';
import { EmploymentCompensationState } from '../../employment-compensation/employment-compensation-models';
import { EnrollmentOptions } from '../models/new-hire-enrollment-models';
import { useNewHireEnrollmentOptions } from './useNewHireEnrollmentOptions';


export function useNewHireEnrollmentAllowed() {


	const employerId = useSelector<TcsmStates, string>(state => state.institutionState?.currentInstitution?.org_guid);
	const employmentId = useSelector<TcsmStates, number>(state => state.employmentState?.currentEmployment?.id);

	const options = useSelector<TcsmStates, EnrollmentOptions>(state => state?.newHireEnrollmentState?.enrollmentOptions);

	const loaded = useNewHireEnrollmentOptions(employerId, employmentId ? `?employment_id=${employmentId}` : null);

	const orgOffersGHL = (options?.benefit_options ? Object.keys(options?.benefit_options)?.length > 0 : false) && loaded;

	return  orgOffersGHL;
}

export function useOnlyOtpEmployment() {

	const employmentCompState = useSelector<TcsmStates, EmploymentCompensationState>(state => state?.employmentCompensationState);
	const employmentCompensationOneTimePayments = employmentCompState?.employmentCompensation[0]?.compensations?.otp;
	const employmentCompensationScheduledPayments = employmentCompState?.employmentCompensation[0]?.compensations?.compensations;
	const hasOnlyOtp = employmentCompensationOneTimePayments?.length > 0 && (!employmentCompensationScheduledPayments?.length || employmentCompensationScheduledPayments?.length === 0);

	return hasOnlyOtp;
}